import React from "react";
import { View, Text, Modal, Pressable, StyleSheet, Dimensions } from "react-native";
import { COLORS, FONTS } from "../../utils";

const { width, height } = Dimensions.get("window");

const SubscribeModal = ({ visible, onClose, onSubscribe }) => {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <Text style={styles.title}>Subscription Required</Text>
          <Text style={styles.message}>
            You need to subscribe to access this feature.
          </Text>

          <View style={styles.buttonContainer}>
            <Pressable style={[styles.button, styles.cancelButton]} onPress={onClose}>
              <Text style={styles.cancelText}>Cancel</Text>
            </Pressable>

            <Pressable style={[styles.button, styles.subscribeButton]} onPress={onSubscribe}>
              <Text style={styles.subscribeText}>Subscribe Now</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default SubscribeModal;

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: width * 0.8,
    backgroundColor: COLORS.white,
    borderRadius: 12,
    padding: 20,
    alignItems: "center",
  },
  title: {
    fontFamily: FONTS.PoppinsBold,
    fontSize: 18,
    marginBottom: 10,
    color: COLORS.primary,
    textAlign: "center",
  },
  message: {
    fontFamily: FONTS.PoppinsRegular,
    fontSize: 14,
    marginBottom: 20,
    textAlign: "center",
    color: "#333",
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  button: {
    flex: 1,
    paddingVertical: 12,
    marginHorizontal: 5,
    borderRadius: 8,
    alignItems: "center",
  },
  cancelButton: {
    backgroundColor: "#E0E0E0",
  },
  cancelText: {
    fontFamily: FONTS.PoppinsMedium,
    color: "#555",
  },
  subscribeButton: {
    backgroundColor: COLORS.primary,
  },
  subscribeText: {
    fontFamily: FONTS.PoppinsMedium,
    color: COLORS.white,
  },
});
